import { render, staticRenderFns } from "./SalaryTable.vue?vue&type=template&id=0afc5219"
import script from "./SalaryTable.vue?vue&type=script&lang=js"
export * from "./SalaryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports